import QuizStatuses from '@/constant/QuizStatuses'
import constants from '@/constant'
import store from '@/vuex/store'
import renderCanvasBlocksUtils from '@/utils/renderCanvasBlocksUtils'

const { defaultQuestionTitle, defaultHeadingTitle } = constants

const isLastSlide = (state) => {
  const { slides } = state.presentation
  const lastSlide = slides.length ? slides[slides.length - 1] : null
  return state.slideActive.id && lastSlide && lastSlide.id === state.slideActive.id
}

const isStartPresentingFromLastSlide = (state) => {
  const { slides } = state.presentation
  const lastSlide = slides.length ? slides[slides.length - 1] : null
  return state.startPresentingFromSlideId === lastSlide.id
}

const getSlideActive = (state) => {
  return state.slideActive
}

const isLobbyScreen = (state) => {
  return state.slideActive.quizStatus == QuizStatuses.LOBBY_SCREEN
}

const questionHasImageXLarge = (state) => {
  return !!(state.slideActive.image && state.slideActive.image.xLarge)
}

const isTextColourLight = (state) => {
  return state.slideActive.textColour === '#ffffff'
}

const isQuestionImageEnabled = (state) => {
  let isEnable = state.slideActive.type === constants.SLIDE_TYPE.PICK_ANSWER && (
    state.slideActive.slideType === constants.SLIDE_TYPE.TYPE_ANSWER || !state.slideActive.slideType)
  if (store.getters['featureToggles/canMergePickImageIntoPickAnswer']) {
    // keep legacy behaviour when remove feature toggle
    isEnable = isEnable || state.slideActive.slideType === constants.SLIDE_TYPE.PICK_IMAGE
  }
  return isEnable
}

const isQuestionImageAndHasImageXLargeEnabled = (state) => {
  return questionHasImageXLarge(state) && isQuestionImageEnabled(state)
}

const isShowFullImageQuestion = (state) => {
  return state.slideActive.showFullImageQuestion && questionHasImageXLarge(state)
}

const hasSlideId = (state) => {
  return state.slideActive?.id ?? false
}

const isContentSlide = () => {
  return store.getters['slideType/isContentSlide']
}

const hasSlideTitle = (state) => {
  return !isContentSlide() && hasSlideId(state) && state.slideActive?.title?.length > 0
}

const hasDefaultTitle = (state) => {
  const defaultTitles = [defaultHeadingTitle, defaultQuestionTitle]

  return hasSlideTitle(state) && defaultTitles.includes(state.slideActive.title.trim())
}

const hasDefaultCanvasBlockLayout = (state) => {
  if (!state.slideActive || !isContentSlide() || !state.slideActive.canvasBlocks) return false

  return renderCanvasBlocksUtils.isDefaultCanvasBlocks(state.slideActive.canvasBlocks)
}

const isDefaultSlide = (state) => {
  return !hasSlideTitle(state) || hasDefaultTitle(state) || hasDefaultCanvasBlockLayout(state)
}

export default {
  isLastSlide,
  getSlideActive,
  isStartPresentingFromLastSlide,
  isLobbyScreen,
  questionHasImageXLarge,
  isTextColourLight,
  isQuestionImageEnabled,
  isShowFullImageQuestion,
  isQuestionImageAndHasImageXLargeEnabled,
  hasSlideId,
  isDefaultSlide,
}
